module.exports = __webpack_public_path__ + "static/assets/b5653010dcf7e8df354f098fde4404e0.svg";